import beehiivThumbnail from './beehiiv.svg'
import kitThumbnail from './convertkit.svg'
import discordThumbnail from './discord.svg'
import echobrainThumbnail from './echobrain.svg'
import fallbackThumbnail from './fallback.svg'
import instagramThumbnail from './instagram.svg'
import klaviyoThumbnail from './klaviyo.svg'
import layloThumbnail from './laylo.svg'
import linktreeThumbnail from './linktree.svg'
import mailchimpThumbnail from './mailchimp.svg'
import merchtrainThumbnail from './merchtrain.svg'
import metaCAPIThumbnail from './meta-capi.svg'
import metaThumbnail from './meta.svg'
import packiyoThumbnail from './packiyo.svg'
import pledgeThumbnail from './pledge.svg'
import ripplingThumbnail from './rippling.svg'
import shipstationThumbnail from './shipstation.svg'
import spotifyThumbnail from './spotify.svg'
import streamelementsThumbnail from './streamelements.svg'
import streamlabsThumbnail from './streamlabs.svg'
import tiktokThumbnail from './tiktok.svg'
import tiktokShopThumbnail from './tiktokShop.svg'
import twitchGiftingThumbnail from './twitchGifting.svg'
import twitchMembershipsThumbnail from './twitchMemberships.svg'
import twitterShopsThumbnail from './twitter.svg'
import vimmiThumbnail from './vimmi.svg'
import youtubeThumbnail from './youtube.svg'
import zapierThumbnail from './zapier.svg'

export const thumbnails = {
  beehiivThumbnail,
  discordThumbnail,
  echobrainThumbnail,
  instagramThumbnail,
  kitThumbnail,
  klaviyoThumbnail,
  layloThumbnail,
  linktreeThumbnail,
  mailchimpThumbnail,
  merchtrainThumbnail,
  metaThumbnail,
  metaCAPIThumbnail,
  packiyoThumbnail,
  pledgeThumbnail,
  ripplingThumbnail,
  shipstationThumbnail,
  spotifyThumbnail,
  streamelementsThumbnail,
  streamlabsThumbnail,
  tiktokThumbnail,
  tiktokShopThumbnail,
  twitchGiftingThumbnail,
  twitchMembershipsThumbnail,
  twitterShopsThumbnail,
  vimmiThumbnail,
  youtubeThumbnail,
  zapierThumbnail,
  fallbackThumbnail,
}
